var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-checkable cog-input",
      class: [
        _vm.allowOther && "cog-checkable--allow-other",
        _vm.hasColumns ? _vm.columnClasses : "cog-checkable--inline",
        _vm.readonly && "is-read-only",
        _vm.isCard && "cog-checkable--card",
        "cog-checkable--label-on-" +
          (!_vm.hasAtLeastOneImage || _vm.hideChoiceLabels
            ? "bottom"
            : _vm.cardLabelPosition),
        _vm.hasAtLeastOneImage && _vm.choiceImageSizeClass,
        _vm.isPersonField && _vm.hasAtLeastOneImage && "cog-checkable--avatars"
      ]
    },
    [
      _vm.readonly
        ? [
            !_vm.selectedOptions.length
              ? [_vm._v(" ")]
              : _vm._l(_vm.selectedOptions, function(option, i) {
                  return _c(
                    "div",
                    {
                      key: option.value,
                      staticClass: "cog-checkable__item is-read-only",
                      class: {
                        "cog-inner-col__item": _vm.hasColumns,
                        "cog-checkable__item--no-label":
                          _vm.hideChoiceLabels && _vm.hasImage(option)
                      },
                      style: _vm.isCard ? `order: ${_vm.optionOrder[i]}` : null
                    },
                    [
                      _vm._t(
                        "readonly-item",
                        function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "cog-choice-option",
                                style: !_vm.isCard
                                  ? `order: ${_vm.optionOrder[i]}`
                                  : null
                              },
                              [
                                _vm.hasImage(option)
                                  ? _c(
                                      "CChoiceImage",
                                      _vm._b(
                                        {},
                                        "CChoiceImage",
                                        {
                                          option,
                                          isPersonField: _vm.isPersonField,
                                          choiceImageSize: _vm.choiceImageSize,
                                          fontSize: _vm.fontSize
                                        },
                                        false
                                      )
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !(_vm.hideChoiceLabels && _vm.hasImage(option))
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cog-choice__readonly-label"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "cog-choice__value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("breakWords")(
                                                  option.label
                                                    ? option.label
                                                    : option.displayValue
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm.isCard && option.description
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "cog-choice__description"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.cleanChoiceDescription(
                                                      option.description
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        },
                        { item: option }
                      )
                    ],
                    2
                  )
                })
          ]
        : [
            _c(
              "el-checkbox-group",
              {
                attrs: { role: null, label: null },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.internalValue,
                  callback: function($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue"
                }
              },
              [
                _vm._l(_vm.options, function(option, i) {
                  return _c(
                    "el-checkbox",
                    {
                      key: option.value,
                      staticClass: "cog-checkable__item cog-choice-option",
                      class: [
                        { "cog-inner-col__item": _vm.hasColumns },
                        {
                          "cog-checkable__item--no-label":
                            _vm.hideChoiceLabels && _vm.hasImage(option)
                        }
                      ],
                      style: `order: ${_vm.optionOrder[i]}`,
                      attrs: { label: option.value },
                      scopedSlots: _vm._u(
                        [
                          !_vm.isCard && _vm.hasImage(option)
                            ? {
                                key: "image",
                                fn: function() {
                                  return [
                                    _vm.hasImage(option)
                                      ? _c(
                                          "CChoiceImage",
                                          _vm._b(
                                            {},
                                            "CChoiceImage",
                                            {
                                              option,
                                              isPersonField: _vm.isPersonField,
                                              choiceImageSize:
                                                _vm.choiceImageSize,
                                              fontSize: _vm.fontSize
                                            },
                                            false
                                          )
                                        )
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              }
                            : null
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm.isCard
                        ? [
                            _c("ICardCheck", {
                              staticClass: "cog-choice__card-checkmark"
                            }),
                            _vm._v(" "),
                            _vm.hasImage(option)
                              ? _c(
                                  "CChoiceImage",
                                  _vm._b(
                                    {},
                                    "CChoiceImage",
                                    {
                                      option,
                                      isPersonField: _vm.isPersonField,
                                      choiceImageSize: _vm.choiceImageSize,
                                      fontSize: _vm.fontSize
                                    },
                                    false
                                  )
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !(_vm.hideChoiceLabels && _vm.hasImage(option))
                              ? _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "cog-choice__value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("breakWords")(
                                            option.label || option.displayValue
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  option.description
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "cog-choice__description"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.cleanChoiceDescription(
                                                option.description
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._v(" "),
                      !_vm.isCard &&
                      !(_vm.hideChoiceLabels && _vm.hasImage(option))
                        ? [
                            _c("span", { staticClass: "cog-choice__value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("breakWords")(
                                    option.label
                                      ? option.label
                                      : option.displayValue
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            option.description
                              ? _c(
                                  "span",
                                  { staticClass: "cog-choice__description" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.cleanChoiceDescription(
                                          option.description
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _vm.allowOther
                  ? _c(
                      "el-checkbox",
                      {
                        staticClass:
                          "cog-checkable__allow-other cog-choice-option",
                        class: {
                          "is-checked": _vm.otherIsChecked,
                          "cog-inner-col__item": _vm.hasColumns
                        },
                        style: `order: ${_vm.optionOrder[_vm.options.length]}`,
                        attrs: {
                          value: _vm.otherIsChecked,
                          label: _vm.otherValue
                        },
                        on: { change: _vm.handleOtherCheckChange }
                      },
                      [
                        _c("el-input", {
                          ref: "other",
                          attrs: {
                            placeholder: _vm.$resource(
                              "field-choice-other-fill-in"
                            )
                          },
                          on: {
                            focus: _vm.handleOtherInputFocus,
                            blur: _vm.handleOtherInputBlur
                          },
                          model: {
                            value: _vm.otherValue,
                            callback: function($$v) {
                              _vm.otherValue = $$v
                            },
                            expression: "otherValue"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }